const APPURL = 'https://afrikeveilapi.yanfoma.com/v1/';

export default {
  LINK: APPURL
};
